import React from "react";
import {TechStack,ToolStack} from "../../../Components";
import { CgCPlusPlus } from "react-icons/cg";
import { Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiAndroid,
  

  
} from "react-icons/di";

import {SiFlutter, SiJava, SiFirebase ,SiVisualstudiocode,
    SiPostman,
    SiHeroku,SiMysql,} from "react-icons/si";

import '../../../Styles/Stack.css'

const Skills = (props) => {
  return (
    <>
    <div style={{border:'1px solid #be50f4',borderRadius:'25px',padding:'20px'}}>
    <h1  style={{color:'black'}} className="fontsizes">
             Professional <strong className="purple">Skillset </strong>
            </h1>
      <Row style={{ justifyContent: "center" }}>
        <TechStack Tech={<CgCPlusPlus/>} />
        <TechStack Tech={<SiJava/>} />
        <TechStack Tech={<DiJavascript1/>} />
        <TechStack Tech={<DiNodejs/>} />
        <TechStack Tech={<DiReact/>} />
        <TechStack Tech={<DiAndroid/>} />
        <TechStack Tech={<SiFlutter/>} />
       
      </Row>
      </div>
      <br/>
     
      <div style={{border:'1px solid #be50f4',borderRadius:'25px',padding:'20px'}}>
      <h1 className="project-heading fontsizes">
          <strong className="purple">DATABASES</strong>
        </h1>
      <Row style={{ justifyContent: "center", paddingTop: "0px" }}>
      <TechStack Tech={<SiMysql/>} />
      <TechStack Tech={<DiMongodb/>} />
      <TechStack Tech={<SiFirebase/>} />
     

      </Row>
      </div>

      <br/>

      <div style={{border:'1px solid #be50f4',borderRadius:'25px',padding:'20px'}}>
      <h1 className="project-heading fontsizes">
          <strong className="purple">IDE'S and Tools</strong>
        </h1>
      <Row style={{ justifyContent: "center", paddingTop: "0px" }}>
          <ToolStack Tool={<SiVisualstudiocode/>}/>
          <ToolStack Tool={<SiPostman/>}/>
          <ToolStack Tool={<SiHeroku/>}/>
      </Row>
      </div>
    </>
  );
};

export default Skills;
